import { render } from "./App.vue?vue&type=template&id=552848c5"
const script = {}
script.render = render

export default script